import { Paper, Tab, Tabs } from '@mui/material';
import { Box } from '@mui/system';
import axios from 'axios';
import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
  CustomButton,
  SaveButton,
  SubmitButton,
} from '../../../components/common/button/CustomButtons';
import formatDate from '../../../components/common/formatDate';
import ChildHeader from '../../../components/ui/ChildHeader';
import { useQuery } from '../../../hooks/UseQuery';
import { useAuth } from '../../../services/auth/AuthProvider';
import TController from './create/TController';
import useGetData from './helpers/useGetData';
import { getColumnLength } from '../helpers/utils';
import { GoSync } from 'react-icons/go';

interface MyData {
  moduleData: any;
  handelSync: any;
  DialogSync: any;
  isLoading: boolean;
  error?: string | null;
}

const Create = () => {
  const { state } = useAuth();
  const navigate = useNavigate();
  const isView = useQuery('isView') === 'true' ? true : false;
  const annual_date = useQuery('annual_date');
  const created_date = useQuery('created_date');
  const department_id = useQuery('department_id');

  const { moduleData, isLoading, error, handelSync, DialogSync }: MyData =
    useGetData(annual_date, created_date, department_id);

  const onSubmit = async (isSubmitted: boolean) => {
    if (moduleData._id) {
      axios
        .put(`/api/salaryRoute/${moduleData._id}`, moduleData)
        .then((res) => {
          window.alert('succesfully updated');
          navigate(-1);
        })
        .catch((err) => console.log(err));
    } else {
      moduleData.department_type = department_id;
      moduleData.isSubmitted = isSubmitted;
      moduleData.month_year = annual_date;
      moduleData.created_date = created_date;
      axios
        .post(`/api/salaryRoute`, moduleData)
        .then((res) => {
          window.alert('succesfully updated');
          navigate(-1);
        })
        .catch((err) => console.log(err));
    }
  };

  return (
    <Box>
      <Box>
        <ChildHeader text="Monthly Salary">
          {!isView && (
            <>
              <CustomButton
                sx={{
                  backgroundColor: '#228be6',
                  color: '#e7f5ff',
                  mr: 2,
                }}
                icon={<GoSync />}
                size="large"
                disabled={!moduleData._id}
                onClick={() => handelSync()}
              >
                Sync All Parts
              </CustomButton>
              <SubmitButton label="Save" onClick={() => onSubmit(true)} />
            </>
          )}
        </ChildHeader>
      </Box>
      <TController
        {...{
          moduleData,
          isView,
        }}
        numberOfDay={getColumnLength(annual_date || '')}
      />
      <DialogSync isSubmitContent={false} />
    </Box>
  );
};

export default Create;
